// frontend/src/hooks/useDashboardState.js

import { useReducer, useCallback } from 'react';

const initialState = {
  pacientes: [],
  pacienteSelecionado: '',
  sessoesDoPaciente: [],
  sessaoSelecionada: '',
  evolucao: '',
  searchTerm: '',
  filteredPacientes: [],
  loading: false,
};

const dashboardReducer = (state, action) => {
  switch (action.type) {
    case 'SET_PACIENTES':
      return { ...state, pacientes: action.payload };
    case 'SET_PACIENTE_SELECIONADO':
      return {
        ...state,
        pacienteSelecionado: action.payload,
        sessaoSelecionada: '',
        sessoesDoPaciente: [],
        evolucao: '',
      };
    case 'SET_SESSOES_PACIENTE':
      return { ...state, sessoesDoPaciente: action.payload };
    case 'SET_SESSAO_SELECIONADA':
      return { ...state, sessaoSelecionada: action.payload };
    case 'SET_EVOLUCAO':
      return { ...state, evolucao: action.payload };
    case 'SET_SEARCH_TERM':
      return { ...state, searchTerm: action.payload };
    case 'SET_FILTERED_PACIENTES':
      return { ...state, filteredPacientes: action.payload };
    case 'SET_LOADING':
      return { ...state, loading: action.payload };
    case 'RESET_FORM':
      return {
        ...state,
        sessaoSelecionada: '',
        evolucao: '',
      };
    default:
      return state;
  }
};

const useDashboardState = () => {
  const [state, dispatch] = useReducer(dashboardReducer, initialState);

  const setPacientes = useCallback((pacientes) => {
    dispatch({ type: 'SET_PACIENTES', payload: pacientes });
  }, []);

  const setPacienteSelecionado = useCallback((id) => {
    dispatch({ type: 'SET_PACIENTE_SELECIONADO', payload: id });
  }, []);

  const setSessoesPaciente = useCallback((sessoes) => {
    dispatch({ type: 'SET_SESSOES_PACIENTE', payload: sessoes });
  }, []);

  const setSessaoSelecionada = useCallback((id) => {
    dispatch({ type: 'SET_SESSAO_SELECIONADA', payload: id });
  }, []);

  const setEvolucao = useCallback((texto) => {
    dispatch({ type: 'SET_EVOLUCAO', payload: texto });
  }, []);

  const setSearchTerm = useCallback((termo) => {
    dispatch({ type: 'SET_SEARCH_TERM', payload: termo });
  }, []);

  const setFilteredPacientes = useCallback((pacientes) => {
    dispatch({ type: 'SET_FILTERED_PACIENTES', payload: pacientes });
  }, []);

  const setLoading = useCallback((loading) => {
    dispatch({ type: 'SET_LOADING', payload: loading });
  }, []);

  const resetForm = useCallback(() => {
    dispatch({ type: 'RESET_FORM' });
  }, []);

  return {
    state,
    setPacientes,
    setPacienteSelecionado,
    setSessoesPaciente,
    setSessaoSelecionada,
    setEvolucao,
    setSearchTerm,
    setFilteredPacientes,
    setLoading,
    resetForm,
  };
};

export default useDashboardState;
